import { Injectable } from '@angular/core';

// SERVICES
import { Observable } from 'rxjs';

import { EnvironmentUtilService } from '../../util';
import { ApiService } from '../api.service';
@Injectable({
  providedIn: 'root',
})
export class OrderClientPurchaseService {
  environment = this.environmentUtilService.getEnvironment();
  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}
  createShareableLink(invoiceId :number) :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV2}/orders/client-purchases/shareable-tokens/${invoiceId}`,
    });
  }
}
